import React, { useMemo } from 'react'
import { List as ListAntd, Typography } from 'antd'
import { useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { Button, Card, Modal } from 'src/components/Ant'

import RenderHotel from './render-hotel'

type Props = {
  toggle(): void
  visible: boolean
}

function ModalHistory({ toggle, visible }: Props): JSX.Element {
  const {
    hotels: { historyList, historyError, historyLoading }
  } = useSelector((state: ApplicationState) => ({
    hotels: state.hotels
  }))

  const hotelList = useMemo(
    () =>
      !historyLoading && !historyError
        ? historyList?.request_quote_hotel_routes?.[0]
            ?.request_quote_hotel_groups
        : [],

    [historyLoading, historyError, historyList]
  )

  return (
    <Modal
      closable
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            toggle()
          }}
          size="default"
          title="common.actions.cancel"
          type="default"
        />
      ]}
      forceRender
      maskClosable
      onCancel={() => {
        toggle()
      }}
      title="web.services.hotels.history-title"
      visible={visible}
      width={820}
    >
      {historyError ? (
        <Typography.Text>{historyError}</Typography.Text>
      ) : (
        <Card loading={historyLoading}>
          <ListAntd
            dataSource={hotelList}
            itemLayout="vertical"
            renderItem={hotel => <RenderHotel hotel={hotel} />}
          />
        </Card>
      )}
    </Modal>
  )
}

export default ModalHistory
